import React from 'react';
import styled from 'styled-components/native';

import { P } from '../components/Typography';
import Colors from '../constants/Colors';
import { missingBirthDateBlocksTransition } from './plugins/transition-conditions/UserDataFieldCondition';

const Notice = styled(P)`
  width: 100%;
  margin-bottom: 12px;
  text-align: center;
`;

export function transitionNoticeMessage(
  options: Parameters<typeof missingBirthDateBlocksTransition>[0]
): string | undefined {
  if (missingBirthDateBlocksTransition(options)) {
    return 'A birth date is required before you can continue. Please add your birth date to your profile.';
  }
  return undefined;
}

const FormTransitionNotice: React.FC<{ message: string }> = ({ message }) => (
  <Notice accessibilityLiveRegion='polite' color={Colors.error} center>
    {message}
  </Notice>
);

export default FormTransitionNotice;
